<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="vehicle_list" :search="search" class="elevation-1 mytable" dense>
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Vehicle Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"></span>
          <v-row justify="center" dense>
            <v-col sm="3" md="1" cols="12"></v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                hide-details></v-text-field>
            </v-col>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Vehicle</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field v-model="editedItem.serial_number" :rules="[
                            v => !!v || 'Serial Number is required',
                            v => (v && v.length <= 50) || 'Serial Number must be less than 50 characters'
                          ]" label="Serial Number" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="editedItem.vehicle_number" :rules="[
                            v => !!v || 'Vehicle Number is required',
                            v => (v && v.length <= 20) || 'Vehicle Number must be less than 20 characters'
                          ]" label="Vehicle Number" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model.number="editedItem.capacity" :rules="[
                            v => !!v || 'Capacity is required',
                            v => Number.isInteger(Number(v)) || 'Capacity must be a number'
                          ]" label="Capacity" type="number" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="editedItem.gps_device_id" :rules="[
                            v => !!v || 'GPS Device ID is required',
                            v => (v && v.length <= 100) || 'GPS Device ID must be less than 100 characters'
                          ]" label="GPS Device ID" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-file-input v-model="editedItem.uploadFile" label="Vehicle file"
                            prepend-icon="mdi-file-document" persistent-hint @change="handleFileChange"></v-file-input>
                          <!-- Show current file only when editing -->
                          <div v-if="editedIndex > -1 && editedItem.image_file_path" class="mt-2">
                            <a :href="basepath + editedItem.image_file_path" target="_blank" class="text-primary"
                              style="font-size: 14px; text-decoration: underline;">
                              Current File: {{ editedItem.image_file_name }}
                            </a>
                          </div>
                        </v-col>


                        <v-col cols="6">
                          <v-checkbox v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:[`item.image_file_path`]="{ item }">
          <span v-if="item.image_file_path">
            <v-btn text color="primary" icon title="download">
              <a :href="basepath + item.image_file_path" target="_blank" style="text-decoration: none">
                <v-icon>mdi-eye</v-icon>
              </a>
            </v-btn>
          </span>
          <span v-else>-</span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-icon class="edit-v-icon mr-1" size="26" color="primary" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon class="mr-2" size="25" @click="deleteItem(item)" color="error">mdi-delete</v-icon>
          </div>
        </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    data: () => ({
      valid: false,
      overlay: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      dialog: false,
      headers: [
        {
          text: "Serial Number",
          align: "left",
          sortable: true,
          value: "serial_number",
        },
        {
          text: "Vehicle Number",
          align: "left",
          sortable: true,
          value: "vehicle_number",
        },
        {
          text: "Capacity",
          align: "left",
          sortable: true,
          value: "capacity",
        },
        {
          text: "GPS Device ID",
          align: "left",
          sortable: true,
          value: "gps_device_id",
        },
        {
          text: "View File",
          align: "left",
          sortable: false,
          value: "image_file_path",
        },
        {
          text: "Active",
          align: "left",
          sortable: true,
          value: "isactive",
        },
        { text: "Actions", value: "action", sortable: false },
      ],
      vehicle_list: [],
      editedIndex: -1,
      editedItem: {
        id: null,
        serial_number: "",
        vehicle_number: "",
        capacity: null,
        gps_device_id: "",
        image_file_name: null,
        image_file_path: null,
        uploadFile: null,
        isactive: true,
      },
      defaultItem: {
        id: null,
        serial_number: "",
        vehicle_number: "",
        capacity: null,
        gps_device_id: "",
        image_file_name: null,
        image_file_path: null,
        uploadFile: null,
        isactive: true,
      },
    }),

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "New Vehicle" : "Edit Vehicle";
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    mounted() {
      this.basepath = localStorage.getItem("awspath");
      this.onLoad();
    },

    methods: {
      async onLoad() {
        this.overlay = true;
        try {
          const res = await axios.get("/TransportLearnerAttendance/getVehicle");
          this.overlay = false;
          if (res.data.Vehicle_list) { // Updated to match backend's response key
            this.vehicle_list = res.data.Vehicle_list;
            this.image_file_name = res.data.image_file_name;
          } else if (res.data.msg && (res.data.msg === "401" || res.data.msg === "403")) {
            this.showSnackbar("#b71c1c", "Unauthorized access");
          } else if (res.data.msg === "404") {
            this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
          } else {
            this.showSnackbar("#b71c1c", "Failed to load Vehicles");
          }
        } catch (error) {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong...");
          console.error("Error loading vehicles:", error);
        }
      },

      editItem(item) {
        // alert("item---" + JSON.stringify(item));
        this.editedIndex = this.vehicle_list.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.editedItem.uploadFile = null; // Reset file input for edit
        this.image_file_name = item.image_file_name ? item.image_file_name : "";
        this.dialog = true;
      },

      async deleteItem(item) {
        if (!confirm(`Are you sure you want to delete Vehicle '${item.serial_number}'?`)) return;
        try {
          const res = await axios.post("/TransportLearnerAttendance/deleteVehicle", {
            deleteid: item.id,
            name: item.serial_number
          });
          if (res.data.status && res.data.status.code === "SUCCESS") {
            this.showSnackbar("#4caf50", "Vehicle Deleted Successfully");
            await this.onLoad();
          } else {
            this.showSnackbar(
              "#b71c1c",
              res.data.status ? res.data.status.message : "Failed to delete Vehicle"
            );
          }
        } catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          console.error("Error deleting vehicle:", error);
        }
      },

      handleFileChange(file) {
        this.editedItem.uploadFile = file;
      },

      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      async save() {
        if (!this.valid) return;

        const formData = new FormData();
        const payload = {
          serial_number: this.editedItem.serial_number.trim(),
          vehicle_number: this.editedItem.vehicle_number.trim(),
          capacity: this.editedItem.capacity != null ? Number(this.editedItem.capacity) : 0,
          gps_device_id: this.editedItem.gps_device_id.trim(),
          isactive: this.editedItem.isactive,
        };

        formData.append("data", JSON.stringify(payload));
        if (this.editedItem.uploadFile) {
          formData.append("uploadFile", this.editedItem.uploadFile);
        }

        if (this.editedIndex > -1) {
          // Edit
          formData.append("editid", this.editedItem.id);
          try {
            const res = await axios.post("/TransportLearnerAttendance/editVehicle", formData, {
              headers: { "Content-Type": "multipart/form-data" }
            });
            if (res.data.status && res.data.status.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Vehicle Updated Successfully");
              await this.onLoad();
            } else if (res.data.status && res.data.status.code === "NA") {
              this.showSnackbar("#b71c1c", res.data.status.message);
            } else if (res.data.msg === "404") {
              this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
            } else {
              this.showSnackbar("#b71c1c", "Failed to update Vehicle");
            }
          } catch (error) {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            console.error("Error during vehicle edit:", error);
          }
        } else {
          // Save new
          try {
            const res = await axios.post("/TransportLearnerAttendance/saveVehicle", formData, {
              headers: { "Content-Type": "multipart/form-data" }
            });
            if (res.data.status && res.data.status.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Vehicle Added Successfully");
              await this.onLoad();
            } else if (res.data.status && res.data.status.code === "NA") {
              this.showSnackbar("#b71c1c", res.data.status.message);
            } else if (res.data.msg === "404") {
              this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
            } else {
              this.showSnackbar("#b71c1c", "Failed to add Vehicle");
            }
          } catch (error) {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            console.error("Error during vehicle save:", error);
          }
        }
        this.close();
      },
    },
  };
</script>

<style scoped>
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }

  .v-icon-size {
    font-size: 20px;
  }

  .edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
  }

  .edit-avatar:hover {
    background-color: #b0bec5;
  }

  .edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
  }

  .edit-v-icon:hover {
    color: white;
  }
</style>